import React from 'react'
import { BiUser, BiLock } from 'react-icons/bi'
import InputField from './InputField'
import SubmitButton from './SubmitButton'
import ForgotPasswordLink from './ForgotPasswordLink'

const LoginForm = ({ login, onEmailChange, onPasswordChange, onSubmit }) => (
    <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-8">
        <form className="space-y-6" onSubmit={onSubmit}>
            <InputField
                label="Usuário"
                type="text"
                placeholder="Digite seu usuário"
                value={login.email}
                onChange={onEmailChange}
                icon={BiUser}
            />
            
            <InputField
                label="Senha"
                type="password"
                placeholder="Digite sua senha"
                value={login.senha}
                onChange={onPasswordChange}
                icon={BiLock}
            />
            
            <SubmitButton />
            
            <ForgotPasswordLink />
        </form>
    </div>
)

export default LoginForm